import { JSX } from 'solid-js';
import { Theme } from './theme-constants';

interface ThemeSelectorProps {
  onThemeChange(theme: Theme): void;
}

export const ThemeSelector = (props: ThemeSelectorProps): JSX.Element => {
  return (
    <modus-wc-theme-switcher
      aria-label="Theme toggle"
      data-testid="theme-switcher"
      on:themeChange={(e: CustomEvent<{ mode: string }>) => {
        props.onThemeChange(e.detail.mode as Theme);
      }}
    />
  );
};

export default ThemeSelector;
